<template>
  <div class="news">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <!-- <div class="page-background">
          <img :src="require('@/assets/customer/canvas.png')" alt="" />
        </div> -->
        <div class="por-container">
          <div class="page-info">
            <div class="page-info-title">{{ navigationList[navigationIndex].text }}</div>
            <div class="page-info-sebtitle">{{ navigationList[navigationIndex].sebtitle }}</div>
          </div>
        </div>
      </div>
      <div class="about-navigation-wrap">
        <div class="navigation-content">
          <div class="about-breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于华跃</el-breadcrumb-item>
              <el-breadcrumb-item :to="{path: navigationList[navigationIndex].router}">{{ navigationList[navigationIndex].text }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="about-navigation-list">
            <div
              v-for="(item, index) in navigationList"
              :key="index"
              class="navigation-item"
              :class="{'navigation-place': navigationIndex == index}"
              @click="switchRoutes(item, index)"
            >{{ item.text }}</div>
          </div>
        </div>
      </div>
      <router-view />
      <div>
        <div ref="customer-stories">
          <div class="customer-stories">
            <div class="customer-stories-content">
              <div class="title">中大型企业的共同选择</div>
              <div class="customer-stories-list">
                <div v-for="(item, index) in enterpriseList" :key="index" class="cystiner-stirues-item">
                  <img :src="item" alt="" />
                </div>
              </div>
              <div class="customer-stories-btn" @click="moreEnterprise">
                <div class="btn-text">
                  查看更多案例
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getContentList } from '@/api/content';
export default {
  name: 'NewsView',
  data() {
    return {
      navigationIndex: 0,
      navigationList: [
        {
          id: 0,
          text: '华跃资讯',
          sebtitle: '了解华跃科技最新动态',
          router: '/news/huayue',
        },
        {
          id: 1,
          text: '行业资讯',
          sebtitle: '了解行业内部最新动态',
          router: '/news/industry',
        },
        {
          id: 2,
          text: '联系我们',
          sebtitle: '',
          router: '/news/contactUs',
        },
      ],
      enterpriseList: [],
    };
  },
  watch: {
    '$route': {
      handler(to, from) {
        for (var i = 0; i < this.navigationList.length; i++) {
          if (this.navigationList[i].router === to.path) {
            this.navigationIndex = i;
            return;
          }
        }
        // this.navigationList.filter((item, index) => {
        //   this.navigationIndex = index;
        //   return item.router === to.path;
        // });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted () {
    this.getPartner();
  },
  methods: {
    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 18, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.enterpriseList.push(result.data[i].logo);
        }
      });
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
    switchRoutes(item, index) {
      this.navigationIndex = index;
      this.$router.push({ path: item.router, });
    },
    openBealter() {
      this.$refs.altProduct.tobealter();
       },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.news {
  background-color: #fff;
  position: relative;
  .page-content {
    width: 100%;
    .page-canvas {
      width: 100%;
      height: 360px;
      min-width: var(--minwidth);
      background: url("@/assets/news/canvas.png") no-repeat;
      background-size: cover;
      background-position: center;
      .por-container {
        width: 70%;
        min-width: var(--minwidth);
        height: 100%;
        margin: 0 auto;
        position: relative;
        .page-info {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .page-info-title {
            color: #fff;
            font-size: 36px;
            font-family: OPPOSans-R;
            line-height: 1;
            margin-bottom: 18px;
          }
          .page-info-sebtitle {
            color: #fff;
            font-size: 16px;
            font-family: OPPOSans-R;
            line-height: 1;
          }
        }
      }
    }
  }
  .about-navigation-wrap{
        width: 100%;
        height: 60px;
        background-color: #fff;
        .navigation-content{
            width: 1200px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ebe8e8;
            .about-breadcrumb{
                height: 100%;
                padding-left: 1px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                ::v-deep .el-breadcrumb{
                    .el-breadcrumb__item{
                        .el-breadcrumb__inner.is-link{
                            color: #606266;
                            font-weight: 400;
                        }
                        &:last-child{
                            .el-breadcrumb__inner.is-link{
                                color: #00b0dc;
                                font-weight: 400
                            }
                        }
                    }
                }
            }
            .about-navigation-list{
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .navigation-item{
                    font-size: 14px;
                    color: #737c8b;
                    margin: 0 15px;
                    cursor: pointer;
                    &:last-child{
                        margin-right: 0;
                    }
                }
                .navigation-place{
                    color: #00b0dc;
                }
            }
        }
    }
  .customer-stories{
      display: flex;
      flex-direction: column;
      background: url('@/assets/staffmanage/customer-back.png') center;
      background-size: cover;
      height: 561px;
      padding: 69px 0 60px;
      box-sizing: border-box;
      .customer-stories-content{
        width: 1200px;
        // min-width: var(--minwidth);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-weight: 500;
          color: #181818;
          margin-bottom: 70px;
        }
        .customer-stories-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .cystiner-stirues-item{
            width: calc(16.666% - 20px);
            height: 70px;
            margin: 10px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;
            padding: 10px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
        }
        .customer-stories-btn{
          width: 155px;
          height: 50px;
          background-color: #2979ff;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          .btn-text{
            font-size: 15px;
            color: #ffffff;
          }
          &:hover{
            transform: scale(1.1);
            transition: all  0.5s;
          }
        }
      }
    }
}
</style>
